import "./VerifyEmail.css";
import { verifyEmail } from "../../service/api.service";
import { useEffect, useState } from "react";
import mailNotVerified from "../../assets/svg/mail-non-verified.svg";

const VerifyEmail = () => {
  const [_verifiedEmailStatus, setVerifiedEmailStatus] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    verifyEmail(token)
      .then(() => {
        setVerifiedEmailStatus(true);
      })
      .catch((e) => {
        setVerifiedEmailStatus(false);
      });
  }, []);

  return (
    <div className="VE-body">
      <h1 className="header-text">EHS Verify Email</h1>
      {_verifiedEmailStatus ? (
        <div className="content-block">
          <p className="verified-text">Email Verified</p>
          <div className="instructions">
            <p className="statement">
              Click on
              <img
                className="mail-icon"
                alt="mail warning"
                src={mailNotVerified}
              />{" "}
              in footer navigator of app to get verified status and access to
              appointment booking.
            </p>
          </div>
        </div>
      ) : (
        <div className="content-block">
          <p>Your Verify Email link is expired.</p>
          <p>Try again</p>
          <div className="instructions">
            <p>Instructions to verify your Email: </p>
            <p className="statement">
              Step 1. Click on
              <img
                className="mail-icon"
                alt="mail warning"
                src={mailNotVerified}
              />
              in footer navigator of app
            </p>
            <p className="statement">
              Step 2. Click on "Send" button to get your email verification link
            </p>
            <p className="statement">
              Step 3. Check your email inbox and click on provided link in mail
              to get your email verified
            </p>
            <p className="statement">
              Step 4. Click on
              <img
                className="mail-icon"
                alt="mail warning"
                src={mailNotVerified}
              />{" "}
              to get verified status and access to appointment booking!!!
            </p>
          </div>
        </div>
      )}
      <div className="instructions">
        <p className="statement">
          Note: If
          <img className="mail-icon" alt="mail warning" src={mailNotVerified} />
          is not present in footer navigator, your Email is verified already!
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
